$(document).on('ajax:beforeSend', '.resend-btn', function() {
  $(this).addClass('disabled');
  $(this).html('<i class="fa fa-spinner fa-spin fa-fw"></i>');
});
